import { io, Socket } from 'socket.io-client';

let socket: Socket | null = null;

const getSocketUrl = (): string => {
  const apiUrl = import.meta.env.VITE_API_URL || '';

  // If VITE_API_URL is a relative path like /web/rest, use current origin
  if (apiUrl.startsWith('/') || !apiUrl) {
    return window.location.origin;
  }

  // If full URL like http://localhost:3000/web/rest, extract the origin
  try {
    const url = new URL(apiUrl);
    return url.origin;
  } catch {
    return window.location.origin;
  }
};

export const getSocket = (): Socket => {
  if (socket) return socket;

  const token = localStorage.getItem('adminToken');

  socket = io(getSocketUrl(), {
    path: '/web/rest/socket.io',
    auth: { token: token ? `Bearer ${token}` : '' },
    transports: ['websocket'],
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 2000,
  });

  socket.on('connect', () => {
    console.log('[Socket] Connected');
  });

  socket.on('disconnect', (reason) => {
    console.log('[Socket] Disconnected:', reason);
  });

  socket.on('connect_error', (err) => {
    console.error('[Socket] Connection error:', err.message);
  });

  return socket;
};

export const disconnectSocket = (): void => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
